<template>
  <div class="remote">
    <div class="remote__main">
      <div class="remote__main__header">Remote</div>
      <div class="remote__main__filter">
        <div class="remote__main__filter__wrapper">
          <div class="remote__main__filter__wrapper__search">
            <div class="remote__main__filter__wrapper__search__form">
              <span><i class="adx-ic_search"></i></span>
              <input
                ref="search" 
                type="text" 
                name="title" 
                id="title" 
                class="search-title" 
                autocomplete="off" 
                placeholder="Search device name"
                v-model="searchText"
                @keyup="keyUp">
            </div>
            <button class="primary btn-regular" @click.stop="searchDevices">search</button>
          </div>
          <div class="remote__main__filter__wrapper__dropdown">
            <p> Filter by: </p>
            <div>
              <adx-dropdown-sort :labelButton="`All Filter`"
            :value.sync="selectedFilter" :type="true" :options="sort"></adx-dropdown-sort>
            </div>
          </div>
        </div>
      </div>
        <div class="remote__main__list">
          <table v-if="!isLoading && !isEmpty">
            <thead>
              <th class="header">Connection</th>
              <th class="header">Location</th>
              <th class="header">Action</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in devices" :key="index">
                <td v-if="item.version < 46" class="dotNotVersion"></td>
                <td v-else>
                  <div v-if="item.is_connected == true" class="dotConnect"></div>
                  <div v-else-if="item.is_connected == false" class="dotDisconnect"></div>
                </td>
                <td class="column">{{item.name}}</td>
                <td style="text-align:'center'">
                  
                    <button v-if="item.status.toLowerCase() == 'closed'" @click="openWindow(item)"
                            type="button" 
                            :class="['primary btn-regular']">
                            Open Port</button>
                  
                    <button v-else
                            @click="tunnelClose(item)"
                            type="button" 
                            :class="['primary btn-regular']">
                            Close Port</button>

                    <button class="btn-regular primary" @click.stop="gotoPanel(item)"> Panel </button>
                    <i v-if="item.version < 46" class="icon-refresh" :disabled="true"> </i>
                    <i v-else class="icon-refresh" @click.stop="refresh(item)"></i></td>
              </tr>
            </tbody>
          </table>
          <div v-if="isLoading" class="loadingState"><adx-loading slot="loading" /></div>
          <div v-if="isEmpty && !isLoading"  class="emptyState">
            <adx-empty-selection />
          </div>
          <div class="pagination" v-if="!isLoading && !isEmpty">
            <adx-pagination 
              :selectedPage="selectedPage" 
              :maxPage="maxPage" 
              @change-page="selectPage"/>
          </div>
        </div>
      </div>

      <adx-modal v-if="showControlPanel" title ="Control panel" @modal-close="toggleModal">
        <div slot="content" class="controlPanel">
          <table>
            <thead>
              <th class="header">Name</th>
              <th class="header">City</th>
              <th class="header">Area</th>
              <th class="header">Version</th>
              <th class="header">Smart TV</th>
            </thead>
            <tbody>
              <tr>
                <td class="column">{{dataModal.name}}</td>
                <td class="column">{{dataModal.city}}</td>
                <td class="column">{{dataModal.cluster}}</td>
                <td class="column">{{dataModal.version}}</td>
                <td v-if="dataModal.is_smart_tv == true" class="column">Yes</td>
                <td v-else class="column">No</td>
              </tr>
            </tbody>
          </table>
          <div class="panel">
            <div class="panel__wrapper__volume">
              <h1> Volume: </h1>
              <adx-input inputId="volumeInput" class="right" :label="`Percentage`" :disabled="false" :value="dataModal.volume" :icon="`percent`"/>
            </div>
            <div class="panel__wrapper__tv">
              <h1> TV Power: </h1>
              <adx-toggle ref='tv' :value="getTvStatus()" :itemId="dataModal.uuid"> </adx-toggle>
            </div>
          </div>
          <div class="controlPanel__bottom">
          <adx-loading v-if="isPanelLoading" class="loadingSubmit" slot="loading"/>
          <button v-else class="btn-regular primary" @click.stop="changeStatus(dataModal)"> Submit </button>
          </div>
        </div>
      </adx-modal>
    </div>
</template>

<script>
import Toggle from '@/components/Toggle'
import Input from '@/components/Form/Input'
import { apiV2 } from '@/api/urls'
import Modal from '@/components/Modal'
import api from '@/api'
import DropdownSort from '@/components/Form/SelectDropdown'
import Loading from '@/components/Loading/Primary'
import EmptySelection from '@/components/NotFound/Selection'
import Pagination from '@/components/Pagination'
export default {
  name: 'adx-remote',
  components: {
    'adx-toggle': Toggle,
    'adx-input': Input,
    'adx-modal': Modal,
    'adx-loading': Loading,
    'adx-empty-selection': EmptySelection,
    'adx-pagination': Pagination,
    'adx-dropdown-sort': DropdownSort,
  },
  props: {

  },
  data() {
    return {
      isLoading: false,
      isEmpty : false,
      devices: [],
      messageTimeout: null,
      showControlPanel: false,
      dataModal: null,
      selectedPage: 1,
      maxPage: 0,
      tvStatus: true,
      isPanelLoading: false,
      searchText: '',
      message: '',
      maxPage: 0,
      selectedPage: 1,
      sort: [
        {
          'id': 0,
          'label': 'All',
          'value': 'all'
        },
        {
          'id': 1,
          'label': 'Connected',
          'value': 'connect'
        },
        {
          'id': 2,
          'label': 'Disconnected',
          'value': 'disconnect'
        },
        {
          'id': 3,
          'label': 'Not supported version',
          'value': 'not_support'
        },
      ],
      selectedFilter: 'all',
    }
  },
  computed: {
    
  },
  watch: {
    selectedFilter: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedPage = 1
        this.selectedFilter = newValue
        this.getDevices()
      }
    }
  },
  beforeCreate() {

  },
  created() {
    this.getDevices()
  },
  beforeMount() {
    
  },
  mounted() {
    
  },
  beforeUpdate() {

  },
  updated() {
    
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    selectPage(item) {
      this.selectedPage = item
      this.getDevices()
    },
    keyUp(ev){
      this.searchText = this.$refs.search.value
      if (ev.keyCode == 13) {
        this.getDevices()
      }
    },
    searchDevices(){
      this.searchText = this.$refs.search.value
      this.getDevices()
    },
    getTvStatus (){
      let tvStatus = this.dataModal.tv == 'on' ? true : false 
      return tvStatus
    },
    gotoPanel(item){
      this.showControlPanel = !this.showControlPanel
      this.dataModal = item
    },
    changeStatus(item) {
      let tvStatus = this.$refs.tv.picked
      let data = {
        'on': tvStatus,
        'volume': document.getElementById('volumeInput').value,
        'device_id': item.id,
        'is_master': item.is_master
      };
      (async () => {
        const response = await api.patch(apiV2.tvControl, data, { needToken: true})
        if (response.status == 200) {
          this.isPanelLoading = true
          setTimeout(() =>{
            this.toggleModal()
            this.getDevices()
            this.isPanelLoading = false
          },3000)
        } else {
        }
      })();
    },
    toggleModal(){
      this.showControlPanel = !this.showControlPanel
    },

    getDevices(){
      (async()=>{
        let param = {
          page: this.selectedPage
        }

        if (this.selectedFilter != 'all'){
          param.status_connection = this.selectedFilter
        }
        if(this.searchText){
          param.title = this.searchText
        }
        this.isLoading = true
        const response = await api.get(apiV2.remoteDeviceList, { needToken: true, params: param })
        if(response.status == 200){
          this.devices = response.data.results
          this.isEmpty = false
          this.isLoading = false
          this.maxPage = response.data.max_page
        }
        if(!response.data.results.length){
          this.isEmpty = true
        }
      })();
    },
    openWindow(device) {
      window.open(`/admin/remote/terminal/?id=${device.id}&isMaster=${device.is_master}`,'','width=700,height=500,status=1,scrollbars=1,resizable=0,left=400,top=200')
    },
    tunnelClose(device){
      (async()=>{
        const data = {
          device_id: device.id,
          is_master : device.is_master,
          message: 'close_tunnel' 
        }
        const response = await api.post(apiV2.createMessage, data, { needToken: true })
        if (response.status == 201){
          window.close()
          clearTimeout(this.messageTimeout)
          this.getDevices()
        }
        else{
          this.messageTimeout= setTimeout(this.tunnelClose,5000)
        }
      })();
    },
    refresh(device){
      (async()=>{
        const data = {
          device_id: device.id,
          is_master : device.is_master,
          message: 'refresh' 
        }
        const response = await api.post(apiV2.createMessage, data, { needToken: true })
        if (response.status == 201){
          this.isLoading = true
          setTimeout(()=>{
            this.getDevices()
            this.isLoading = false
          },5000)
        }
        else{
          
        }
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>


